/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import * as React from 'react';

import { Router, Route } from 'react-router-dom';

import { UtilisateurZustandProvider } from './components/Zustand';

// eslint-disable-next-line @typescript-eslint/naming-convention,react/prop-types
const Context = (p) => {
  const { children, path, history, scope, user } = p;

  return (
    <Router history={history}>
      <Route path={path}>
        {scope === 'content' ? (
          <UtilisateurZustandProvider user={user}>
            {React.isValidElement(children)
              ? children
              : React.createElement(children)}
          </UtilisateurZustandProvider>
        ) : React.isValidElement(children) ? (
          children
        ) : (
          React.createElement(children)
        )}
      </Route>
    </Router>
  );
};

export default Context;
